import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["startDate", "endDate"]

    periodChanged() {
        // Clear dates so server calculates them from period
        this.startDateTarget.value = ""
        this.endDateTarget.value = ""
        this.element.requestSubmit()
    }
}
